module.exports = __webpack_public_path__ + "static/Akshay_Deogiri-b1dde2c6b616f9a2a1cadcc97068fd33.jpeg";